/* SS - Sticky add-to-cart button (mobile), v2 "B". See snippets/ss-sticky-atc.liquid.
   Mirrors the theme's real add-to-cart button: same text, and hidden entirely while that
   button is disabled for a sold-out variant. Submits the theme's own form (form attribute). */
(function () {
  'use strict';
  var bar = document.querySelector('[data-ss-sticky-atc]');
  if (!bar || bar.dataset.ssReady) return;
  bar.dataset.ssReady = '1';
  var form = document.getElementById(bar.getAttribute('data-form'));
  if (!form) return;
  var realBtn = form.querySelector('.add-to-cart, [data-add-to-cart]');
  var btn = bar.querySelector('.ss-sticky-atc__btn');
  if (!realBtn || !btn) return;

  document.body.appendChild(bar);   // fixed positioning must not sit under a transformed ancestor

  var passed = false;               // real button scrolled above the viewport, and footer not yet reached?
  /* 19.09.2026 (Kristoffer): the button disappears as soon as the footer enters the viewport - no extra
     bottom padding on <body> any more (it showed as a blank strip under the footer). */
  var footer = document.querySelector('footer.ss-f') || document.querySelector('footer');
  function soldOut() { return realBtn.disabled && !realBtn.classList.contains('btn--loading'); }
  function apply() {
    var on = passed && !soldOut();
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('ss-sticky-atc-open', on);
  }
  function mirror() {
    btn.disabled = soldOut();
    var t = realBtn.querySelector('[data-add-to-cart-text]') || realBtn;
    var txt = (t.textContent || '').trim();
    if (txt) btn.textContent = txt;
    apply();
  }
  function check() {
    var r = realBtn.getBoundingClientRect();
    var atFooter = false;
    if (footer) { var f = footer.getBoundingClientRect(); atFooter = f.width > 0 && f.top < window.innerHeight; }
    passed = r.bottom < 0 && r.width > 0 && !atFooter;
    apply();
  }
  var last = 0;
  function onScroll() {               // time-throttled, not rAF: rAF pauses in background tabs
    var now = Date.now();
    if (now - last < 40) { clearTimeout(onScroll.t); onScroll.t = setTimeout(check, 60); return; }
    last = now; check();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', check);
  setTimeout(check, 400);
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function () { check(); }, { threshold: [0, 1] });
    io.observe(realBtn); if (footer) io.observe(footer);
  }
  if (window.MutationObserver) {
    new MutationObserver(function () { mirror(); }).observe(realBtn, { attributes: true, childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('variant:change', function () { setTimeout(mirror, 60); });

  mirror();
  check();
})();
